<template>
  <div>
    <Head title="API & Webhooks" />
    <h1 class="mb-8 text-3xl font-bold">
      <span class="text-indigo-400 hover:text-indigo-600">API/</span> Tokens</h1>

    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden mb-4">
      <form @submit.prevent="generateNewToken">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="token_name" :error="token_name_error" class="pb-8 pr-6 w-full lg:w-1/3" label="Emri i tokenit"/>

          <text-input v-model="newToken" class="pb-8 pr-6 w-full lg:w-2/3" label="Token" disabled info="Tokeni do të shfaqet vetëm një herë, ruani atë në një vend të sigurt!"/>
        </div>

        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button  class="btn-indigo ml-auto" type="submit">Gjenero</loading-button>
        </div>
      </form>
    </div>

    <div  class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Emri</th>
          <th class="pb-3 pt-6 px-6">Përdorimi i fundit</th>
          <th class="pb-3 pt-6 px-6">Krijuar më</th>
          <th class="pb-2 pt-6 px-6"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="token in tokens.data" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" >
              {{ token.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4"  tabindex="-1">
              {{ token.last_used_at }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4"  tabindex="-1">
              {{ token.created_at }}
            </Link>
          </td>
          <td class="border-t">
            <button tabindex="-1" type="button"><icon name="trash" class="flex-shrink-0 mr-2 w-6 h-6 fill-red-600" @click="destroyToken(token.id)"/></button>
          </td>
        </tr>
        <tr v-if="tokens.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">Nuk u gjet asnjë token.</td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import Icon from '@/Shared/Icon'
import LoadingButton from '@/Shared/LoadingButton'
import TextInput from '@/Shared/TextInput'
import {Head, Link} from '@inertiajs/inertia-vue3'
import axios from 'axios'
import {Inertia} from '@inertiajs/inertia'



export default {
  components: {
    Head,
    Link,
    Icon,
    LoadingButton,
    TextInput
  },
  layout: Layout,
  props:{
    tokens: Object,
  },
  data(){
    return{
      token_name: null,
      token_name_error: null,
      newToken: null
    }
  },
  methods: {
    destroyToken(tokenId){
      if (confirm('Kujdes! Ky token nuk mund të rikthehet më. A jeni të sigurt se dëshironi të vazhdoni?')) {
        this.$inertia.delete(`/api/tokens/${tokenId}`)
      }
    },
    generateNewToken(){
      self = this;

      axios.post(route('api.new.token'),{
          token_name: this.token_name,
      }).then(function (result){
        if(result.data.errors && result.data.errors.token_name){
          self.token_name_error =  result.data.errors.token_name[0];
          self.newToken = null
        }
        else{
          self.token_name_error = null;
          self.newToken = result.data.newToken
          Inertia.reload();
        }
      })
    }
  }
}
</script>
